<app-back-to-system-overview relativeUrl="../../"></app-back-to-system-overview>

<api-call-gate [apiCall]="systemOverviewService.entireOverview">
  @if (checkIfCoolingSystemComponent()) {
    <ng-template #lastSuccessfulData>
      <sh-nav-bar slot="nav">
        <sh-tabs>
          <sh-tab-item
            label="Pattern Match"
            [active]="tabOrder === 1"
            (click)="tabOrder = 1; activateTabAndUpdateQueryParams()"
            (keydown.enter)="activateTabAndUpdateQueryParams()"
          ></sh-tab-item>
          <sh-tab-item
            label="Cooling System"
            [active]="tabOrder === 2"
            (click)="tabOrder = 2; activateTabAndUpdateQueryParams()"
            (keydown.enter)="activateTabAndUpdateQueryParams()"
          ></sh-tab-item>
        </sh-tabs>
      </sh-nav-bar>
      <div *ngIf="tabOrder === 1">
        <app-pattern-match
          [systemDetails]="systemDetails$ | async"
          [filterName]="patternMatchDataService.filterName$ | async"
        ></app-pattern-match>
      </div>
      <div *ngIf="tabOrder === 2">
        <app-cooling-system-details></app-cooling-system-details>
      </div>
    </ng-template>
  } @else {
    <ng-template #lastSuccessfulData>
      @if (externalWebApp$ | async; as app) {
        <iframe
          [src]="app | processPlaceholders | sanitizeResourceUrl"
        ></iframe>
      } @else {
        @switch (dataSourceGroupId$ | async) {
          @case (1) {
            <app-coils [systemDetails]="systemDetails$ | async"></app-coils>
          }
          @case (5) {
            <app-tube [systemDetails]="systemDetails$ | async"></app-tube>
          }
          @case (7) {
            <app-tube [systemDetails]="systemDetails$ | async"></app-tube>
          }

          <!-- everything else is pattern match -->
          @default {
            <app-pattern-match
              [systemDetails]="systemDetails$ | async"
              [filterName]="patternMatchDataService.filterName$ | async"
            ></app-pattern-match>
          }
        }
      }
    </ng-template>
  }
</api-call-gate>
